<template>
  <v-dialog
    v-model="getDialog"
    @click:outside="handleClickOutSite"
    ref="dialog"
    max-width="464px"
    :content-class="checkScroll"
    content-class="parent-dialog"
  >
    <v-card>
      <v-card-title>
        <span class="title-text" tabindex="0">{{ $t('bubble_chart.title_popup_bubble_chart_color') }}</span>
      </v-card-title>
      <v-card-text class="content">
        <div v-for="colorItem in listColor" class="content-center" :key="colorItem.id">
          <div class="content-bubble">
            <div class="bubble-color" :class="colorItem.color"></div>
            <div class="dropdown-wrapper">
              <dropdown
                ref="dropdowns"
                :type="colorItem.color"
                :dataList="filteredItems[colorItem.color] || []"
                :placeholder="pulldownSelected.placeholder"
                :arrowDownBtn="true"
                :hasSearch="true"
                :keyCheckbox="keyCheckbox"
                :valueCheckbox="valueCheckbox"
                :searchPlacehoder="pulldownSelected.textSearchPlaceholder"
                :selectedProp="selectedProp[colorItem.color]"
                @updateData="updateData"
              />
            </div>
          </div>
        </div>
        <button-custome
          icon="close-menu.svg"
          iconHover="close-menu.svg"
          iconDisable="addregistericon_disabled.svg"
          typeIcon="icons"
          :isSmallButton="true"
          :buttonText="$t('bubble_chart.popup_cancel_all')"
          :isDisable="disableBoundaryInput"
          @action="handleClearDropdown"
          class="boundary-btn"
        >
        </button-custome>
      </v-card-text>
      <v-card-actions>
        <common-button @action="close" :label="closeBtnLabel"></common-button>
        <common-button :buttonType="confirmBtnClass" @action="handleSubmit" :label="confirmBtnLabel"></common-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ButtonCustome from '@/components/commonApp/ButtonIconCustom';
import CommonButton from '@/components/commonApp/ButtonCustom/NewButton.vue';
import Dropdown from '../commonApp/Dropdown.vue';
import { mapActions } from 'vuex';

export default {
  components: { CommonButton, ButtonCustome, Dropdown },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    confirmBtnClass: {
      type: String,
      default: 'warning-btn',
    },
    confirmText: {
      type: String,
      default: '決定',
    },
    isShowScroll: {
      type: Boolean,
      default: false,
    },
    filterType: {
      type: Number,
    },
    colorConfig: {
      type: Object,
    },
    dataList: {
      type: Array,
    },
  },
  data() {
    return {
      listColor: [
        { id: 1, color: 'bgRed' },
        { id: 2, color: 'bgBlue' },
        { id: 3, color: 'bgGreen' },
        { id: 4, color: 'bgOrange' },
        { id: 5, color: 'bgPurple' },
      ],
      result: {
        product: {},
        category: {},
      },
      disableBoundaryInput: false,
      selectedItems: [],
      filteredItems: {},
      selectedProp: [],
      keyCheckbox: 'id',
      valueCheckbox: 'displayName',
      filterText: null,
    };
  },
  computed: {
    getDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit('update:dialog', value);
      },
    },
    closeBtnLabel() {
      return this.$t('popup.button_cancel');
    },
    confirmBtnLabel() {
      return this.confirmText;
    },
    checkScroll() {
      return this.isShowScroll ? '' : 'hidden-scroll';
    },
    pulldownSelected() {
      const filterText = this.filterText;
      if (filterText === 'product') {
        return {
          textSearchPlaceholder: this.$t('bubble_chart.text_search_product'),
          placeholder: this.$t('bubble_chart.popup_please_select_product')
        }
      } else {
        return {
          textSearchPlaceholder: this.$t('bubble_chart.text_search_category'),
          placeholder: this.$t('bubble_chart.popup_please_select_category')
        }
      }
    }
  },
  methods: {
    ...mapActions('product', ['updateSettingBubble']),
    close() {
      if (this.isLoading) {
        return;
      }
      this.$emit('close');
    },
    handleSubmit() {
      this.$refs.dropdowns.forEach((dropdown) => {
        dropdown.submitData();
      });
      const colorConfig = {};
      if (this.filterText) {
        colorConfig[this.filterText] = {
          ...this.result[this.filterText],
        };
        this.updateSettingBubble({ colorConfig });
      }
      this.$emit('onHighlightSubmit', colorConfig);
    },
    handleClickOutSite() {
      this.close();
    },
    updateData(type, data) {
      this.selectedProp[type] = this.selectedProp[type] || [];
      this.selectedProp[type] = [...data];

      this.result[this.filterText] = {
        ...this.result[this.filterText],
        [type]: data,
      };
      this.selectedItems = [
        ...new Set(
          Object.values(this.result[this.filterText])
            .flat()
            .map((item) => item[this.keyCheckbox]),
        ),
      ];
    },
    getFilterItemList() {
      const validDataList = Array.isArray(this.dataList) ? this.dataList : [];

      const selectedColorData = this.listColor.map((colorItem) => {
        const dataByColor = this.result[this.filterText][colorItem.color];
        
        const result = validDataList.map((product) => {
          const keyValue = product[this.keyCheckbox];
          const isSelected = this.selectedItems.includes(keyValue);
          const hasColor = dataByColor?.some(p => p[this.keyCheckbox] === keyValue);
          const displayName = product.lot_number ? `${product.name}/${product.lot_number}` : product.name;
          const isDisable = isSelected && !hasColor;
          
          return {
            ...product,
            disabled: isDisable,
            displayName: displayName
          };
        });
        return [colorItem.color, [...result]];
      });
      this.filteredItems = Object.fromEntries(selectedColorData);
    },
    handleClearDropdown() {
      this.selectedProp = {};
      this.selectedItems = [];
      this.result[this.filterText] = {};
    },
    resetSelectedProp() {
      const filterText = this.filterText;
      this.selectedProp = { ...(this.colorConfig?.[filterText] || {}) };
    },
  },
  watch: {
    selectedItems: {
      handler() {
        this.getFilterItemList();
      },
    },
    dataList: {
      handler() {
        const filterText = this.filterType === 1 ? 'product' : 'category';
        this.filterText = filterText;
        this.selectedProp = { ...(this.colorConfig?.[filterText] || {}) };
        this.getFilterItemList();
      },
    },
    selectedProp: {
      handler() {
        this.result = { ...this.result, [this.filterText]: { ...this.selectedProp } };
        this.selectedItems = [
          ...new Set(
            Object.values(this.selectedProp)
              .flat()
              .map((item) => item[this.keyCheckbox]),
          ),
        ];
      },
    },
    dialog: {
      handler(newVal) {
        if (newVal) {
          this.resetSelectedProp();
        }
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/components/popup/index.scss';
.v-dialog__content--active {
  ::v-deep .v-dialog {
    overflow-y: unset;
  }
  .parent-dialog {
    .v-card__title {
      display: flex;
      gap: 12px;
      padding: 16px 16px !important;
      img {
        display: flex;
        width: 28px;
        height: 28px;
        padding: 0.5px;
        justify-content: center;
        align-items: center;
      }
      .title-text {
        color: $monoBlack;
        font-family: 'Source Han Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0.42px;
      }
    }
    .v-card__text {
      line-height: 1.5 !important;
      letter-spacing: normal !important;
      font-size: 16px !important;
      font-weight: normal !important;
    }
    .v-card__actions {
      display: flex;
      gap: 8px;
      width: 100%;
    }
    .hidden-scroll {
      overflow-y: unset;
    }
    .content {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 16px 32px 16px 32px !important;
      .content-center {
        .content-bubble {
          display: flex;
          gap: 8px;
          align-items: center;
          .bubble-color {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            flex-shrink: 0;
          }
          .highlight-select {
            flex: 1;
          }
          .dropdown-wrapper {
            width: calc(100% - 28px);
          }
        }
        .bgRed {
          background-color: $bgRed;
        }
        .bgBlue {
          background-color: $bgBlue;
        }
        .bgGreen {
          background-color: $bgGreen;
        }
        .bgOrange {
          background-color: $bgOrange;
        }
        .bgPurple {
          background-color: $bgPurple;
        }

        .boundary-btn {
          width: 83px;
          height: 28px;
        }
      }
      ::v-deep .boundary-btn {
        padding: 6px 8px;
        .icon-default {
          width: 16px;
          padding: 6px 0px;
        }
        .icon-hover {
          width: 16px;
          padding: 6px 0px;
          filter: brightness(0) invert(1);
        }
        .button-custom_text {
          padding: 4px 0px 6px;
        }
      }
    }
  }
}
</style>
